import React, { useEffect } from "react";

const Toast = ({ message, type = "success", onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div
      style={{
        position: "fixed",
        top: "1rem",
        right: "1rem",
        padding: "1rem 1.5rem",
        backgroundColor: type === "success" ? "#4BB543" : "#FF5C5C",
        color: "#fff",
        borderRadius: "4px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        zIndex: 9999,
        fontWeight: "bold",
      }}
    >
      {message}
    </div>
  );
};

export default Toast;
